import React from 'react';
import Picture from "../common/Picture";
import {AnimatePresence, motion} from 'framer-motion';
import {CloseIcon} from '../common/Icons';

const ceoDetails = {
    'Sushant Goenka': {
        bio: "A seeker at heart, Sushant’s life journey has been extremely enriching. His personal choices and professional accomplishments have led him to create something truly valuable for society. All Aces Club stands as the embodiment of his flair, energy, and vision.",
    },
    'Nipun Grover': {
        bio: "A travel enthusiast with an eye for luxury and penchant for elite lifestyle. Nipun’s journeys inspire experiences rooted in luxury, finesse, and modern hospitality.",
    },
    'Shashank Dutt Sharma': {
        bio: "Poet by choice, entrepreneur by destiny, writes with soul and works with purpose. Between rhymes and realities, Shashank’s creativity emerges as a pillar for core design of the club.",
    },
};

interface CeoModalProps {
    isOpen: boolean;
    onClose: () => void;
    designer: { name: string; role: string; image: string; } | null;
}

export const CeoModal: React.FC<CeoModalProps> = ({isOpen, onClose, designer}) => {
    if (!designer) return null;

    const details = ceoDetails[designer.name as keyof typeof ceoDetails];

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                    className="fixed inset-0 top-0 bg-black bg-opacity-70 z-50 flex items-center justify-center p-4"
                    onClick={onClose}
                >
                    <motion.div
                        initial={{scale: 0.9, opacity: 0}}
                        animate={{scale: 1, opacity: 1}}
                        exit={{scale: 0.9, opacity: 0}}
                        className="bg-ivory rounded-lg shadow-xl max-w-lg w-full relative max-h-[90vh] overflow-y-auto"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            onClick={onClose}
                            className="absolute top-4 right-4 text-royal-pine hover:text-logo-color transition-colors z-50"
                        >
                            <CloseIcon className="w-6 h-6"/>
                        </button>
                        <div className="p-6 sm:p-8 flex flex-col items-center">
                            <Picture
                                {...(designer.image.toLowerCase().endsWith('.webp') ? { webpSrc: designer.image } : designer.image.toLowerCase().endsWith('.png') ? { pngSrc: designer.image } : { jpgSrc: designer.image })}
                                alt={designer.name}
                                className="rounded-full w-32 h-32 mx-auto mb-4 object-cover border-4 border-royal-pine"
                                onErrorSrc={'https://placehold.co/150x150/153D40/C6A375?text=Designer'}
                            />
                            <h3 className="heading-font text-2xl font-semibold mb-1 text-royal-pine">{designer.name}</h3>
                            <p className="text-md text-gray-600 font-light mb-6 text-center">{designer.role}</p>
                            <p className="text-sm leading-relaxed text-royal-pine">{details.bio}</p>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};